import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getCookie } from './utils/cookie';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from './services/config.service';

@Injectable()
export class HttpCookieInterceptor implements HttpInterceptor {
  private isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    private injector: Injector,
    private configService: ConfigService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isBrowser) {
      return next.handle(req);
    }
    const apiUrl = this.configService.get('apiUrl');
    if (apiUrl === req.url.substr(0, apiUrl.length)) {
      req = req.clone({withCredentials: true});
    }
    const csrf = getCookie('csrftoken');
    if (csrf) {
      req = req.clone({
        setHeaders: {'X-CSRFToken': csrf}
      });
    }
    return next.handle(req);
  }
}
